import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "analytics-dashboard" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "filter-result" }

import UnderlineTabGroup from '@/design-system/molecules/UnderlineTabGroup.vue'
import DashboardBuildingScoresFilters from './DashboardBuildingScoresFilters.vue'
import CollapseController from '@/components/AnalyticsDashboard/components/CollapseController/CollapseController.vue'
import { InformationQuery } from '@/api-client/models/buildingScore/Contracts'
import { watch, inject, computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { sharedDataKey } from '../../types'
import useFeatures from '@/pinia/features'
import nonEmptyList from '@/utils/nonEmptyList'
import isDefined from '@/utils/isDefined'
import { useResultReport } from '../useResultReport'
import useFetchInformation from '@/api-client/models/buildingScore/useFetchInformation'
import { useI18n } from 'vue-i18n'
import FeatureComponent from '@/components/FeatureComponent.vue'
import { FeatureType, useFilters } from '@/composables/useFilters'
import { useStore } from 'vuex'
import { useTransferState } from '../useTransferState'
type Emits = {
  (e: 'toggleFullscreen'): void
  (e: 'closeDashboard'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardFeatureBuildingScore',
  emits: ["toggleFullscreen", "closeDashboard"],
  setup(__props) {



const { t } = useI18n()
const filters = useFilters(FeatureType.BuildingScore)
const features = useFeatures()
const { pushFeature, replaceFeature } = features
const route = useRoute()

const sharedData = inject(sharedDataKey)

const buttons = [
  {
    text: t('dashboard__text__measurement_values'),
    name: 'kpis',
    onClick: () => {
      replaceFeature('kpis')
    }
  },
  {
    text: t('dashboard__text__chart-graphs'),
    name: 'graphs',
    onClick: () => {
      replaceFeature('graphs')
    }
  }
]
const informationQuery = computed<InformationQuery>(() => {
  return {
    complexes: nonEmptyList([filters.submitted.complex?.belongsToId].filter(isDefined)),
    year: filters.submitted.year,
    constructions: nonEmptyList(filters.submitted.buildings.map((x) => x.id))
  }
})
const submittedInformationQuery = computed<InformationQuery>(() => {
  return {
    complexes: nonEmptyList([filters.submitted?.complex?.belongsToId].filter(isDefined)),
    year: filters.submitted?.year,
    constructions: nonEmptyList(filters.submitted?.buildings.map((x) => x.id))
  }
})
const information = useFetchInformation(informationQuery)
const submittedInformation = useFetchInformation(submittedInformationQuery)
const { result } = useResultReport(
  'buildingScore',
  submittedInformation.data,
  submittedInformation.isLoading
)
const store = useStore()
useTransferState(store)

const isPresentingExpandedFilters = ref(false)
const toggleExpandFilters = () => {
  isPresentingExpandedFilters.value = !isPresentingExpandedFilters.value
}

watch(
  () => route.path,
  (path) => {
    if (path.endsWith('buildingscore')) {
      pushFeature('kpis')
    }
  },
  { immediate: true }
)

onMounted(() => {
  information.fetch()
  sharedData?.updateSectionIndex(0)
})

const computedClass = computed(() => {
  return {
    fullscreen: sharedData?.fullscreen
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(result)), 1)
      ]),
      _createVNode(CollapseController, {
        isCollapsed: !isPresentingExpandedFilters.value,
        showCalendar: false,
        onToggleCollapse: toggleExpandFilters
      }, null, 8, ["isCollapsed"])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "horizontal-divider" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["scrollable-container", computedClass.value])
    }, [
      _createVNode(DashboardBuildingScoresFilters, {
        information: _unref(information).data.value,
        isCollapsed: !isPresentingExpandedFilters.value,
        onFormSubmitted: _cache[0] || (_cache[0] = ($event: any) => (isPresentingExpandedFilters.value = false))
      }, null, 8, ["information", "isCollapsed"]),
      _createVNode(UnderlineTabGroup, {
        buttons: buttons,
        size: 'small',
        style: 'margin-top: 16px;',
        "selected-name": _unref(route).path.split('/').pop()
      }, null, 8, ["selected-name"]),
      _createVNode(FeatureComponent, { feature: "home/analytics/portfolio/buildingscore/*" })
    ], 2)
  ]))
}
}

})